export default "__VITE_ASSET__g99JU_ZI__"